import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "dc-form__group"
};
const _hoisted_2 = ["for"];
const _hoisted_3 = {
  class: "dc-form__control"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  key: 2
};
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  class: "dc-form__select__icon",
  alt: "Arrow Icon",
  "aria-hidden": "true",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  version: "1.1",
  x: "0px",
  y: "0px",
  viewBox: "0 0 1000 1000",
  "enable-background": "new 0 0 1000 1000",
  "xml:space": "preserve"
}, [/*#__PURE__*/_createElementVNode("g", null, [/*#__PURE__*/_createElementVNode("path", {
  d: "M500,775.4L10,287.2l64.4-62.6L500,650.2l425.6-425.6l64.4,62.6L500,775.4z"
})])], -1);
const _hoisted_8 = ["onClick", "onKeyup"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("p", {
    for: $options.randomId,
    class: _normalizeClass(["dc-form__label", {
      'tw-sr-only': _ctx.nolabel
    }])
  }, _toDisplayString($props.label), 11, _hoisted_2), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
    class: "dc-form__select",
    onFocusout: _cache[4] || (_cache[4] = (...args) => $options.handleFocusOut && $options.handleFocusOut(...args))
  }, [_createElementVNode("div", {
    class: _normalizeClass(["dc-form__select__current", {
      'active': $data.isActive
    }]),
    tabindex: "0",
    onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => $options.toggleOnClick && $options.toggleOnClick(...args), ["stop"])),
    onKeyup: _cache[1] || (_cache[1] = (...args) => $options.toggleOnKeydown && $options.toggleOnKeydown(...args)),
    role: "combobox"
  }, [$props.titleAddition ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($props.titleAddition + ": " + $options.selectedOption?.title), 1)) : $props.pageTitleAddition ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString($props.pageTitleAddition.replace('{0}', $options.selectedOption?.title)), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString($options.selectedOption?.title), 1)), _hoisted_7], 34), _createElementVNode("ul", {
    class: _normalizeClass(["dc-form__select__list", $props.hasScrollbar ? 'dc-form__select__scrollbar' : '']),
    style: _normalizeStyle([$data.isActive ? 'display: block;' : 'display: none;', {
      "z-index": "1"
    }]),
    id: "dropdownUl",
    ref: "dropdown",
    onKeydown: _cache[3] || (_cache[3] = (...args) => $options.trapKeyboardFocus && $options.trapKeyboardFocus(...args))
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, option => {
    return _openBlock(), _createElementBlock("li", {
      key: option.id,
      onClick: $event => $options.onSelectOption(option),
      onKeyup: [_withKeys(_withModifiers($event => $options.onSelectOption(option), ["prevent"]), ["enter"]), _cache[2] || (_cache[2] = _withKeys(_withModifiers((...args) => $options.toggleOnKeyDownEscape && $options.toggleOnKeyDownEscape(...args), ["prevent"]), ["escape"]))],
      class: _normalizeClass(["dc-form__select__option", option.title == $options.selectedOption?.title ? 'dc-form__select__selected' : '']),
      tabindex: "0",
      ref_for: true,
      ref: "dropdownList"
    }, _toDisplayString(option.title), 43, _hoisted_8);
  }), 128))], 38)], 32)])]);
}